module.exports = __webpack_public_path__ + "img/company_background.e5ffedff.png";